// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MetricController from "./metric_controller"
application.register("metric", MetricController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import ValidationController from "./validation_controller"
application.register("validation", ValidationController)

import SpecificationsController from "./specifications_controller"
import TableRowController from "./table_row_controller"
import ProductImagesController from "./product_images_controller"
import SlugController from "./slug_controller"
import MobileMenuController from "./mobile_menu_controller"
import MultiSelectController from "./multi_select_controller"
import SingleImageController from "./single_image_controller"
application.register("specifications", SpecificationsController)
application.register("table-row", TableRowController)
application.register("product-images", ProductImagesController)
application.register("slug", SlugController)
application.register("mobile-menu", MobileMenuController)
application.register("multi-select", MultiSelectController)
application.register("single-image", SingleImageController)

import SelectSearchController from "./select_search_controller"
application.register("select-search", SelectSearchController)
import FlashController from "./flash_controller"
application.register("flash", FlashController)
import CalculatorFormController from "./calculator_form_controller"
import LocalizedFieldsController from "./localized_fields_controller"
application.register("calculator-form", CalculatorFormController)
application.register("localized-fields", LocalizedFieldsController)
